export default __webpack_public_path__ + "static/media/BurgerOpen.84f0675a.svg";